import { render } from "./questionComponent.vue?vue&type=template&id=0cbc9f69&scoped=true"
import script from "./questionComponent.vue?vue&type=script&lang=js"
export * from "./questionComponent.vue?vue&type=script&lang=js"

import "./questionComponent.vue?vue&type=style&index=0&id=0cbc9f69&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbc9f69"]])

export default __exports__